import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { loginAsUserAndRedirect } from "../../utils/adminLoginAsUser";

/**
 * Shareable deep link that logs the admin in as a given user and opens a
 * destination page in the main app, authenticated as that user.
 *
 * Runs on load and navigates the current tab — no button, no confirmation.
 * Reachable only through ProtectedRoute, and the session mint itself is
 * gated by @require_super_admin on /admin-support-login, so the link is
 * inert without a valid admin token.
 *
 * Query params:
 *   user_id  (required) — the user to open the app as
 *   redirect (required) — app path ("/document/xyz") or full app URL to land on;
 *                         other origins are refused
 */
const LoginAsPage: React.FC = () => {
  const [params] = useSearchParams();
  const userId = params.get("user_id");
  const redirect = params.get("redirect");
  const [failed, setFailed] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (!userId || !redirect || started.current) return;
    started.current = true;
    loginAsUserAndRedirect(userId, redirect).then((ok) => {
      if (!ok) setFailed(true);
    });
  }, [userId, redirect]);

  if (!userId || !redirect) {
    return (
      <div style={{ padding: 40 }}>
        Missing <code>user_id</code> or <code>redirect</code> query parameter.
      </div>
    );
  }

  return (
    <div style={{ padding: 40, fontSize: 14, color: "#666" }}>
      {failed
        ? "Couldn't log in as this user. Check that your admin token is still valid, then reload."
        : "Signing you in…"}
    </div>
  );
};

export default LoginAsPage;
